import React from 'react'
import clsx from 'clsx'

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import FooterLogo from '@/assets/icons/footer-logo.svg'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { getIconClass, IconType } from '@/helpers/getIconClass'
import { LanguageSwitch } from '@/components/organisms/Header/LanguageSwitch/LanguageSwitch'
import { FooterTypes } from './types'

export function Footer({
  bottom_navigation,
  copyright_navigation,
  description,
  main_navigation,
  className,
  languages,
  currentLang,
  alternates
}: FooterTypes) {
  return (
    <>
      <footer
        className={clsx(
          'text-text-dark-900 flex flex-col tablet:flex-row text-left tablet:justify-between max-w-screen-desktop mx-auto px-20 laptop:px-90 pt-48 tablet:pt-80 pb-0',
          className
        )}
      >
        <div className="tablet:w-4/12">
          <img
            src={FooterLogo}
            alt="Footer"
            className="mb-16 -mt-20 flex mx-0 w-64"
            width={64}
            height={60}
            decoding="async"
            loading="lazy"
          />
          <span className="font-poppins font-bold  text-bodyS tablet:mr-2">
            Beebole © {new Date().getFullYear()} Copyright
          </span>
          <div className="text-bodyL w-full tablet:w-10/12 mt-16 mb-40 tablet:mb-16 tablet:mt-24 text-text-dark-600">
            {typeof description === 'string' ? description : <RichTextField data={description} />}
          </div>
          <ul className="flex flex-col">
            {copyright_navigation &&
              copyright_navigation.map((link) => (
                <li className="text-footerText mb-24 tablet:mb-16 hover:text-text-brand-primary " key={link._uid}>
                  <CustomLink {...link}>{link.text}</CustomLink>
                </li>
              ))}
          </ul>
        </div>

        <div className="flex flex-col tablet:flex-row tablet:w-8/12 tablet:justify-end tablet:text-left">
          {main_navigation &&
            main_navigation.map(({ title, navigation, social, _uid }, index) => (
              <div className="tablet:mr-40 laptop:mr-64 first:mt-0 mt-36 tablet:mt-0" key={_uid}>
                <p className="font-bold text-bodyS mb-24 tablet:my-0 tablet:mb-16 font-poppins">{title}</p>
                <ul className={clsx('flex', social ? 'flex-row justify-start space-x-12' : 'flex-col')}>
                  {navigation &&
                    navigation.map((link) => (
                      <React.Fragment key={link._uid}>
                        {link.is_image ? (
                          <li
                            key={link._uid}
                            className="bg-gray-light h-36 w-36 rounded-full flex justify-center items-center space-x-12"
                          >
                            <CustomLink {...link} aria-label={link.text}>
                              <i
                                className={`fa fa-${getIconClass(link.text as IconType)} text-bodyM text-text-dark-900`}
                                aria-hidden="true"
                              />
                            </CustomLink>
                          </li>
                        ) : (
                          <li className="text-bodyS mb-24 tablet:mb-16 hover:text-text-brand-primary " key={link._uid}>
                            <CustomLink {...link} aria-label={link.text}>
                              {link.text}
                            </CustomLink>
                          </li>
                        )}
                      </React.Fragment>
                    ))}
                </ul>
                {index === main_navigation.length - 1 && (
                  <div className="mt-48">
                    <p className="font-bold text-bodyS mb-16 netbook:mb-24 tablet:my-0 tablet:mb-16 font-poppins">
                      Select language
                    </p>
                    <LanguageSwitch currentLang={currentLang} languages={languages} alternates={alternates} />
                  </div>
                )}
              </div>
            ))}
        </div>
      </footer>

      <div className="bg-primary-700 mt-48 py-20 tablet:mt-80">
        <ul className="flex justify-center flex-wrap leading-8 px-16 tablet:leading-none text-bodyS tablet:space-x-16 text-white">
          {bottom_navigation &&
            bottom_navigation.map(({ text, link_url, _uid }) => (
              <li
                key={_uid}
                className="w-1/2 pb-20 tablet:pb-0 tablet:w-auto tablet:border-r tablet:last:border-0 tablet:pr-16 tablet:last:pr-0 font-poppins"
              >
                <CustomLink link_url={link_url} is_external={false} new_tab={false}>
                  <p className="text-white text-center tablet:text-left">{text}</p>
                </CustomLink>
              </li>
            ))}
        </ul>
      </div>
    </>
  )
}
